import { Injectable } from "@angular/core";
import { AuthServiceBase } from "./auth.service.base";

@Injectable({
  providedIn: 'root'
})
export class AuthMockService extends AuthServiceBase {
  get accessToken(): string {
    return 'mock-access-token';
  }
  get idToken(): string {
    return 'mock-id-token';
  }
  hasValidAccessToken: boolean = true;
  login(): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(this.hasValidAccessToken);
    });
  }
  logout(): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(this.hasValidAccessToken);
    });
  }
  isAuthenticated(): boolean {
    return this.hasValidAccessToken;
  }
  getProfile(): any {
    return { sub: 'mock-user-id', name: 'Mock User' };
  }
}